import React from 'react'
import styles from './style'
import propTypes from './prop'
import { Grid, withStyles } from '@material-ui/core'
import translator from 'src/translate'

import { CoreTextField } from 'src/components/core'

/**
 *
 * @param {*} props
 */
const QuestionFreeform = props => {
  const { classes } = props

  return (
    <Grid container justifyContent="center" alignContent="center">
      <Grid item className={classes.grid}>
        <CoreTextField
          multiline
          rows="5"
          disabled
          row={5}
          fullWidth
          label="Learners' answer area"
          variant="outlined"
        />
      </Grid>
    </Grid>
  )
}

QuestionFreeform.propTypes = propTypes

export default withStyles(styles)(QuestionFreeform)
